// Utility functions for 2026 calendar

export function getDaysInYear(year: number): number {
    // Check if leap year
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 366 : 365;
}

export function getFirstDayOfYear(year: number): number {
    // Returns 0-6 (Sunday-Saturday)
    const date = new Date(year, 0, 1);
    return date.getDay();
}

export function getDayOfYear(date: Date): number {
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = date.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
}

export function getDateFromDayOfYear(year: number, dayOfYear: number): Date {
    const date = new Date(year, 0);
    date.setDate(dayOfYear);
    return date;
}

export function formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
}

export function getDayName(date: Date): string {
    const days = ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'];
    return days[date.getDay()];
}

export function getCurrentDayOfYear(): number {
    return getDayOfYear(new Date());
}

export function isToday(dayOfYear: number, year: number): boolean {
    const now = new Date();
    return now.getFullYear() === year && getDayOfYear(now) === dayOfYear;
}

export function isPast(dayOfYear: number, year: number): boolean {
    const now = new Date();
    const currentYear = now.getFullYear();

    if (year < currentYear) return true;
    if (year > currentYear) return false;

    return dayOfYear < getDayOfYear(now);
}
